var _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconEarthHeart128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0375 107.578C82.0157 107.578 103.075 86.5186 103.075 60.5405C103.075 34.5624 82.0157 13.5029 56.0375 13.5029C30.0594 13.5029 9 34.5624 9 60.5405C9 86.5186 30.0594 107.578 56.0375 107.578Z",
    fill: "#D9D9D9",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2384_9540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 98,
    height: 98
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0375 108.578C82.0157 108.578 103.075 87.5186 103.075 61.5405C103.075 35.5624 82.0157 14.5029 56.0375 14.5029C30.0594 14.5029 9 35.5624 9 61.5405C9 87.5186 30.0594 108.578 56.0375 108.578Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.97
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2384_9540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0375 107.578C82.0157 107.578 103.075 86.5186 103.075 60.5405C103.075 34.5624 82.0157 13.5029 56.0375 13.5029C30.0594 13.5029 9 34.5624 9 60.5405C9 86.5186 30.0594 107.578 56.0375 107.578Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2224 12.0918C66.2224 12.0918 56.4342 17.715 56.2618 26.2419C56.0896 34.7689 67.2389 30.1867 67.2389 36.3442C67.2389 42.5016 59.9707 43.6378 53.4311 37.3785C46.8914 31.119 39.646 30.4118 33.1508 36.0072C26.6556 41.6028 25.5886 56.3241 36.7755 58.6031C47.9627 60.882 49.5935 61.7701 49.5935 73.0942C49.5935 84.4184 51.0665 86.8693 59.8362 86.8693C68.6056 86.8693 63.9178 77.71 67.2389 71.7771C70.56 65.844 76.2998 62.7475 76.2998 57.9241C76.2998 53.1004 65.1592 53.9343 67.2389 47.2007C69.3187 40.4673 79.1883 44.1171 83.9732 41.3043C88.7584 38.4915 92.0312 27.4369 90.725 26.2419C90.122 25.6904 87.9646 22.5655 81.3478 18.5297C78.9656 17.0767 77.1349 15.214 74.2341 14.2862C70.8984 12.9424 66.2224 12.0918 66.2224 12.0918Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4307 118.925L76.9315 97.3523C72.4909 92.6793 72.1332 85.4621 76.09 80.3729C80.5315 74.6599 88.7763 73.6583 94.4565 78.1417L97.4307 80.4888L101.787 77.4323C107.621 73.3396 115.672 74.7808 119.723 80.6433C123.178 85.643 122.654 92.3804 118.468 96.7862L97.4307 118.925Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconEarthHeart128);
export default __webpack_public_path__ + "static/media/pictogramBeaconEarthHeart128.97e9ff78c8d0818295043a99c98b222c.svg";
export { ForwardRef as ReactComponent };